import React from 'react';

const IconLLMAgents = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="48px" height="48px">
    <circle cx="24" cy="24" r="22" fill="#6D28D9" />
    <circle cx="24" cy="10" r="4" fill="#EDE9FE" />
    <circle cx="12" cy="22" r="4" fill="#EDE9FE" />
    <circle cx="36" cy="22" r="4" fill="#EDE9FE" />
    <circle cx="17" cy="36" r="4" fill="#C4B5FD" />
    <circle cx="31" cy="36" r="4" fill="#C4B5FD" />
    <line x1="24" y1="14" x2="12" y2="18" stroke="#A78BFA" strokeWidth="1.5" />
    <line x1="24" y1="14" x2="36" y2="18" stroke="#A78BFA" strokeWidth="1.5" />
    <line x1="12" y1="26" x2="17" y2="32" stroke="#A78BFA" strokeWidth="1.5" />
    <line x1="36" y1="26" x2="31" y2="32" stroke="#A78BFA" strokeWidth="1.5" />
    <line x1="12" y1="26" x2="31" y2="32" stroke="#A78BFA" strokeWidth="1" />
    <line x1="36" y1="26" x2="17" y2="32" stroke="#A78BFA" strokeWidth="1" />
  </svg>
);

export default IconLLMAgents;
